<script setup>
import AppLayout from "../../Layouts/AppLayout.vue";
import PrimaryButton from "../../Components/PrimaryButton.vue";
import {Link, usePage} from "@inertiajs/inertia-vue3";
import SecondaryButton from "../../Components/SecondaryButton.vue";
import MediaUpload from "../../Components/Common/Media/MediaUpload.vue";
import {useHelpers} from "../../helpers";

defineProps({
  media: Object
})
const helpers = useHelpers();
const currentUser = usePage().props.value.auth.user;
</script>

<template>
  <AppLayout title="Sales">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Sales
      </h2>
    </template>

    <div class="max-w-full py-10 sm:px-6 lg:px-8">
      <p class="mb-5">
        <Link :href="route('admin.companies.create')" class="mr-5">
          <PrimaryButton>Create Company</PrimaryButton>
        </Link>
        <Link :href="route('sales.lookbook.index')" class="mr-5">
          <PrimaryButton>Lookbook</PrimaryButton>
        </Link>
        <Link :href="route('sales.salesplan.index')" class="mr-5">
          <PrimaryButton>Sales Plan</PrimaryButton>
        </Link>
        <!--<a href="/content/sales/sales_tracking.php">
          <SecondaryButton>Sales Tracking</SecondaryButton>
        </a>-->
      </p>

      <MediaUpload
        :media-input="media"
        :can-see-upload-form="helpers.userHasPermission(currentUser, 'admin')"
        :can-modify-media-details="helpers.userHasPermission(currentUser, 'admin')"
        :hide-save="false"
        media-location="sales"
      ></MediaUpload>
    </div>
  </AppLayout>
</template>
